import {
  CHAT_ASSIGNED,
  OPERATOR_SEND_MESSAGE,
  OPERATOR_TYPING,
  TRANSFER_COMPLETED,
  CONTINUE_CHAT
} from '../app-communication/actions/from-cluster';

import { CLEAR_STORE } from '../constants';
import {
  USER_UNSEEN_CHAT_MESSAGES,
  USER_RESET_UNSEEN_CHAT_MESSAGES
} from '../app-communication/actions/from-client-frontend';

/**
 * @typedef {Object} OperatorInfo
 * @property {string} first_name
 * @property {string} last_name
 * @property {string} avatar
 * @property {string} job_title
 * @property {string} employ_from
 * @property {string} rating
 * @property {string | {}} biography
 * @property {number} operatorId
 */

/**
 * @typedef {Object} OperatorReducer
 * @property { number } currentOperatorId
 * @property { boolean } operatorIsTyping
 * @property { number } unseenMsgCount
 * @property {Object.<number, OperatorInfo>} [operatorId]
 */
export const initialState = {
  currentOperatorId: null,
  operatorIsTyping: false,
  unseenMsgCount: 0,
  languages: []
};

export const operatorsReducer = (state = initialState, action) => {
  const operator = action.payload && action.payload.operator;
  const operatorId = action.payload && action.payload.operator_id;

  switch (action.type) {
    case CHAT_ASSIGNED:
      return {
        ...state,
        currentOperatorId: operatorId,
        [operatorId]: {
          ...action.payload.operator,
          operatorId
        }
      };
    case TRANSFER_COMPLETED:
      return {
        ...state,
        [operatorId]: {
          ...operator,
          operatorId
        },
        currentOperatorId: operatorId
      };
    case OPERATOR_TYPING:
      return {
        ...state,
        operatorIsTyping: Boolean(action.payload.isTyping)
      };
    case OPERATOR_SEND_MESSAGE:
      return {
        ...state,
        operatorIsTyping: false
      };
    case CONTINUE_CHAT:
      return {
        ...state,
        currentOperatorId: action.payload.currentOperatorId,
        languages: action.payload.languages,
        ...action.payload.operators
      };
    case USER_UNSEEN_CHAT_MESSAGES:
      return {
        ...state,
        unseenMsgCount: state.unseenMsgCount + 1
      };
    case USER_RESET_UNSEEN_CHAT_MESSAGES:
      return {
        ...state,
        unseenMsgCount: 0
      };
    case CLEAR_STORE:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
